module.exports = __webpack_public_path__ + "static/media/YM35_1.03021b78.jpg";